import React, { useEffect, useState } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import { ErrorCode } from '../../../ErrorCode';
import { CLOUD_STATUS_OBSERVE_SPAN } from '../../../Constant';

export type COMM_HIS = {
  REQ_DATE: string; //通信日時
  PRO_CATEGORY: string; //処理分類
  PROCESS_NO: number; //処理番号
  REQ1: string; //データ1
  REQ2: string; //データ2
  REQ3: string; //データ3
  REQ4: string; //データ4
  REQ5: string; //データ5
  REQ6: string; //データ6
  REQ7: string; //データ7
  REQ8: string; //データ8
  REQ9: string; //データ9
  REQ10: string; //データ10
  REQ11: string; //データ11
  REQ12: string; //データ12
  REQ13: string; //データ13
  REQ14: string; //データ14
  REQ15: string; //データ15
  REQ16: string; //データ16
  REQ17: string; //データ17
  REQ18: string; //データ18
  REQ19: string; //データ19
  REQ20: string; //データ20
  REQ21: string; //データ21
  REQ22: string; //データ22
  REQ23: string; //データ23
  REQ24: string; //データ24
  REQ25: string; //データ25
  REQ26: string; //データ26
  REQ27: string; //データ27
  REQ28: string; //データ28
  REQ29: string; //データ29
  REQ30: string; //データ30
  REQ_CONT: number; //リトライ回数
  COMP_FLG: string; //完了フラグ
  PRO_PROGRAM: string; //処理プログラム
  COMP_DATE: string; //完了日時
};

type ColudErrorLogType = {
  CloudErrorStatus: number;
  ResponceData: ResponceDataType;
};

// レスポンス情報
type ResponceDataType = {
  ResponseCode: number;
  ErrorCode: number;
  ResponseMessage: string;
  ErrorMessage: string;
};

const ApiResponseCode = {
  DEFAULT: 200,
  SUCCESS: 204, //要求待ちレコード追加
  EXISTS_RECORD: 406, //既に要求中
  UPDATE_FAILURE: 500, //更新失敗
};

const ButtonStatus = {
  DEFAULT: 0,
  REQUESTING: 1, //サーバアクセス中
  RES_OK: 2,
  RES_NG: 3,
};

//CSVファイルの取得
export const getCloudStatus = (): Promise<ColudErrorLogType> => {
  return new Promise((resolve, reject) => {
    const url = 'api/CloudErrorLog';
    fetch(url)
      .then((res) => res.json())
      .then(
        (result: ColudErrorLogType) => {
          console.debug(['result', result]);
          if (getCloudStatusValidate(result)) {
            resolve(result);
          }
          reject('Invalidate response');
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const getCloudStatusValidate = (data: ColudErrorLogType) => {
  if (data == null) {
    return false;
  }
  return true;
};

// スタイル定義用のフック関数が受け取るプロパティの型
type StyleProps = {
  buttonStyle: number;
};
const useStyles = makeStyles<Theme, StyleProps>({
  paper: {
    cursor: 'pointer' /* マウスポインタの形状 */,
    height: '100%',
    background: (props) => {
      switch (props.buttonStyle) {
        case ButtonStatus.REQUESTING:
          return '#808000';
        case ButtonStatus.RES_OK:
          return '#4CAF50';
        case ButtonStatus.RES_NG:
          return '#FF0000';
        default:
          return '#536DFE';
      }
    },
    color: '#FFFFFF',
    textAlign: 'center',
  },
});

/**
 * クラウドエラー要求をCOMM_HISテーブルにインサートする
 * @returns
 */
const CloudErrorLogCard: React.FC = () => {
  const { t } = useTranslation();

  const [buttonStatus, setButtonStatus] = useState<number>(ButtonStatus.DEFAULT);
  //const [commHis, setCommHis] = useState<COMM_HIS>();

  const getButtonString = (buttonStatus: number) => {
    switch (buttonStatus) {
      case ButtonStatus.REQUESTING:
        return t('CloudErrorLogCard.処理中です', '処理中です');
      case ButtonStatus.RES_OK:
        return t('CloudErrorLogCard.クラウドOK', 'クラウドOK');
      case ButtonStatus.RES_NG:
        return t('CloudErrorLogCard.クラウドNG', 'クラウドNG');
      default:
        return t('CloudErrorLogCard.クラウド情報表示', 'クラウド情報表示');
    }
  };

  const getData = () => {
    getCloudStatus()
      .then((r) => {
        if (r.ResponceData.ErrorCode != ErrorCode.ERR_CODE_NONE) {
          setButtonStatus(ButtonStatus.RES_NG);
        } else {
          switch (r.CloudErrorStatus) {
            case 0:
              return setButtonStatus(ButtonStatus.REQUESTING);
            case 1:
              return setButtonStatus(ButtonStatus.RES_OK);
            case 2:
              return setButtonStatus(ButtonStatus.RES_NG);
            default:
              return setButtonStatus(ButtonStatus.RES_NG);
          }
        }
      })
      .catch((e) => {
        console.error('Experiment completed');
        setButtonStatus(ButtonStatus.RES_NG);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getData();
    const interval = setInterval(() => {
      getData();
    }, CLOUD_STATUS_OBSERVE_SPAN); //  intervals

    return () => {
      clearInterval(interval);
    };
  }, []);

  /** クラウドエラーリクエストボタン処理 */
  const handleCloudErrorClick = () => {
    console.debug(['===buttonStatus====', buttonStatus]);

    //if (buttonStatus != ButtonStatus.REQUESTING) {  //TODO リクエスト中の場合はAPIをコールしない
    fetch('api/CloudErrorLog', {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    })
      .then((resp) => {
        console.debug([resp]);
        if (resp.status == ApiResponseCode.SUCCESS) {
          //クラウドエラー要求をレコード追加
          setButtonStatus(ButtonStatus.REQUESTING);
        } else if (resp.status == ApiResponseCode.EXISTS_RECORD) {
          setButtonStatus(ButtonStatus.REQUESTING);
        } else {
          setButtonStatus(ButtonStatus.DEFAULT);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    //}
  };

  //console.debug(['表示開始', buttonStatus]);
  const classes = useStyles({ buttonStyle: buttonStatus });
  return (
    <Paper className={classes.paper}>
      <Typography variant="h6">
        <div onClick={handleCloudErrorClick}>{getButtonString(buttonStatus)}</div>
      </Typography>
    </Paper>
  );
};

export default CloudErrorLogCard;
